import { type ChildOrder } from '@hooks-api/types/dataModel/fpOrder'
import { Box } from '@pets-ui/Box/Box'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useDeliveryMethod } from '../hooks/use-delivery-method'
import style from '../style/components/order-items.module.scss'
import { VariationComponent } from './variation'

interface Props {
  childOrder: ChildOrder
}

const styles = stylex.create({
  wrapper: {
    padding: '0.5rem',
    borderColor: 'var(--gray-200)',
    borderRadius: '8px',
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: 'var(--white)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '0.5rem',
    width: '100%',
  },
})

export const OrderItems = (props: Props) => {
  const { childOrder } = props
  const { t } = useTranslation()
  const { getI18nDeliveryMethod } = useDeliveryMethod()
  const orderItems = childOrder.order_items
  return (
    <Box width="100%">
      <div className={style.title}>
        {getI18nDeliveryMethod(childOrder.delivery_class)}
        {' - '}
        {t('order.number')}
        &nbsp;
        #
        {childOrder.order_id}
      </div>
      <Box rootStyle={styles.wrapper}>
        {orderItems.map((item) => {
          return (
            <VariationComponent
              key={item.id}
              variation={item}
              className={style.variation}
              projectCode={childOrder.project_code}
              deliveryClass={childOrder.delivery_class}
            />
          )
        })}
      </Box>
    </Box>
  )
}
